
import { Component, Prop, Vue } from 'vue-property-decorator'
import KatexMixedText from '@/components/molecules/KatexMixedText.vue'
import { StudyModel } from '@/models/StudyModel'

/**
 * 設問情報の解答内容表示(日本語手書き)
 */
@Component({
  components: {
    KatexMixedText,
  },
})
export default class ResultJapanese extends Vue {
  /** 設問情報 */
  @Prop()
  private question!: StudyModel.Question

  /** 正答を表示するかユーザ解答を表示するかのフラグ */
  @Prop({ default: false })
  private showCorrect!: boolean

  /**
   * 表示用要素の取得
   *
   * @returns 入力式の表示用要素(配列)
   */
  private get items(): StudyModel.FrontValueJapanese[] {
    return this.question.contents.map((content) => {
      return content.frontValues as StudyModel.FrontValueJapanese
    })
  }
}
